// src/plugins/i18n.js
import { createI18n } from 'vue-i18n'
import messages from '../locales'

// Legacy mode keeps the Vue 2-style global APIs like this.$t()
// globalInjection makes $t available in templates without importing useI18n
export const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: 'uk',         // default language
  fallbackLocale: 'en',
  messages,
  // silence warnings similar to silentTranslationWarn
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
})
